<script lang="ts">
import { defineComponent as DO_defineComponent } from 'vue';
export default /*#__PURE__*/ DO_defineComponent({
	name: 'ToSwitch'
});
</script>
<template>
	<div v-dis.opacity="disabled" v-tip="changed ? t('to.switch.changed') : ''" :flex="flex ? flex : null" class="to-switch" :style="setStyle" :class="setClass" @click="toggle">
		<div class="to-switch-on">
			<div v-if="onText" class="to-switch-on-text">{{ onText }}</div>
			<to-icon v-if="onIcon" class="to-switch-on-icon" :value="onIcon"></to-icon>
		</div>
		<div class="to-switch-off">
			<div v-if="offText" class="to-switch-off-text">{{ offText }}</div>
			<to-icon v-if="offIcon" class="to-switch-off-icon" :value="offIcon"></to-icon>
		</div>
		<div class="to-switch-slider"></div>
	</div>
</template>

<script lang="ts" setup>
import { CSSProperties, computed, ref, watch, inject } from 'vue'
import { t } from '@touchvue/locale'



const ToForm = inject<{ comparable?: boolean }>('ToForm')

const valueStore = ref([])

const props = defineProps({
	flex: Boolean,
	disabled: Boolean,
	modelValue: {
		type: [Boolean, String, Number],
		default: false
	},
	onValue: {
		type: [Boolean, String, Number],
		default: true
	},
	offValue: {
		type: [Boolean, String, Number],
		default: false
	},
	onColor: {
		type: String,
		default: 'primary'
	},
	offColor: {
		type: String,
		default: 'info'
	},
	onText: {
		type: String,
		default: ''
	},
	offText: {
		type: String,
		default: ''
	},
	onIcon: {
		type: String,
		default: ''
	},
	offIcon: {
		type: String,
		default: ''
	},
	color: {
		type: String,
		default: 'default'
	},
	mode: {
		type: String,
		default: 'default'
	},
	beforeChange: {
		type: [Function, String, Boolean],
		default: ''
	},
	comparable: {
		type: Boolean,
		default: false
	},
	width: {
		type: [String, Number],
		default: ''
	}
})

const emit = defineEmits(['update:modelValue', 'change'])

const ivalue = ref(props.modelValue)
const disabled = ref(props.disabled)

watch(
	() => props.modelValue,
	val => {
		ivalue.value = val
	},
	{ immediate: true }
)

watch(
	() => props.disabled,
	val => {
		disabled.value = val
	}
)

const setClass = computed(() => {
	const arr = ['to-disable-target']
	if (ivalue.value === props.onValue) {
		arr.push(`is-on`)
	}
	if (props.color) {
		arr.push(`color-${props.color}`)
	}
	if (props.mode) {
		arr.push(`mode-${props.mode}`)
	}
	if (ToForm?.comparable || props.comparable) {
		arr.push('to-compare')
	}
	if (changed.value) {
		arr.push('to-switch-changed')
	}
	return arr
})

const setStyle = computed(() => {
	const obj: CSSProperties = {}
	if (props.width) {
		obj['--width'] = props.width + 'em'
	}
	return obj
})

const changed = computed(() => {
	if ((props.comparable || ToForm?.comparable) && valueStore.value.length > 0 && ivalue.value !== valueStore.value[0]) {
		return true
	} else {
		return false
	}
})

async function toggle() {
	if (disabled.value) return
	let flag = true
	if (typeof props.beforeChange === 'boolean') {
		flag = props.beforeChange
	} else {
		if (props.beforeChange) {
			if (typeof props.beforeChange === 'function') {
				if (typeof props.beforeChange().then === 'function') {
					flag = await props.beforeChange()
				} else {
					flag = props.beforeChange()
				}
			} else {
				flag = !!props.beforeChange
			}
		}
	}
	if (!flag) return false
	ivalue.value = ivalue.value === props.onValue ? props.offValue : props.onValue
	emit('update:modelValue', ivalue.value)
	emit('change', ivalue.value)
}

const compare = () => {
	valueStore.value.unshift(ivalue.value)
}
// 撤销
const restore = () => {
	ivalue.value = valueStore.value[0]
	valueStore.value.splice(0, 1)
}

const setDisabled = (f: boolean) => {
	disabled.value = f
}
defineExpose({
	compare,
	restore,
	changed,
	setDisabled
})
</script>
